<template>
  <div class="tabs-support tabs-common">
    <p class="common-title">Applicant’s Endorsement</p>
    <div class="mb-3 row">
      <!-- <label class="col-sm-2 col-form-label">Owner</label> -->
      <div class="col-sm-10">
        <input type="text" class="form-control" v-model="tab_data.form_m_user" placeholder="Owner">
        <label>Owner</label>
      </div>
    </div>
    <div class="mb-3 row">
      <!-- <label class="col-sm-2 col-form-label">Status</label> -->
      <div class="col-sm-10">
        <div class="select-wrapper">
          <select v-model="tab_data.action_doc" class="form-control" onchange=" this.dataset.chosen = this.value; " data-chosen="">
            <option value="" disabled>Status</option>
            <option value="Status">Status</option>
          </select>
          <label>Status</label>
        </div>
      </div>
    </div>
    <div class="mb-3 row">
      <!-- <label class="col-sm-2 col-form-label">Owner</label> -->
      <div class="col-sm-10">
        <input type="text" class="form-control" v-model="tab_data.app_name" placeholder="Applicant Name">
        <label>Applicant Name</label>
      </div>
    </div>
    <div class="mb-3 row">
      <!-- <label class="col-sm-2 col-form-label">Prev Users Submission Date</label> -->
      <div class="col-sm-10">
        
        <!-- <input type="text" class="form-control" v-model="tab_data.prev_submiss_date"> -->
      </div>
    </div>
    <div class="mb-3 row">
      <label class="col-sm-2 col-form-label">Comments:</label>
      <div class="col-sm-10">
        <div style="white-space: pre-wrap;">{{ tab_data.so_message }}</div>
        <!-- <input type="text" readonly class="form-control-plaintext"
               value="SUBMITTED"> -->

      </div>
    </div>
    <div class="mb-3 row">
      <div class="col-sm-8">
        <textarea
            type="textarea"
            rows="5"
            placeholder="Enter a description..."
            class="text_area_css"
            :class="{'text_area_none':isRed}"
            v-model="textarea">
        </textarea>
        <p :class="{'active_text':isRed}" v-if="isRed">This is a hint text to help user</p>
      </div>
    </div>
    <button type="button" class="btn btn-outline-secondary btn-sm add-btn" @click="addMessage">Add Message</button>
    <!-- <div class="foot_pagination">
      <img src="@/assets/chevron_left24.png" alt="" v-if="cur_tab_name!='Header'" @click="page_change('Endorsement',6)">
      {{ cur_tab_name }}
      <img src="@/assets/chevron_right24.png" alt="" v-if="cur_tab_name!='Support Information'"
           @click="page_change('',8)">
    </div> -->
  </div>
</template>

<script>
import common from "@/mixins/common-form-m";

export default {
  name: 'tabs-support',
  components: {},
  props: ['cur_tab_name', 'indata'],
  mixins: [common],
  data() {
    return {
      textarea: '',
      isRed: false,
      tab_data: {
        app_name: '',
        app_state: '',
        form_m_user: '',
        so_message: '',
      }
    }
  },
  mounted(){
    this.tab_data.form_m_user = this.$store.state.user.id
  },
  methods: {
    addMessage(){
      this.tab_data.so_message+=`${this.textarea}\n`
      this.textarea = ''
    },
    submit() {
      if (!this.textarea) {
        this.isRed = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.tabs-support {
  .add-btn {
    //styleName: Label/Large;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.10000000149011612px;
    text-align: left;
    color: #333;
  }

  .text_area_css {
    width: 100%;
    resize: none !important;
    height: Fixed (128px);
    padding: 8px;
    border-radius: 8px;
    gap: 8px;
    border: 1px solid #8D8D8D;
  }

  .text_area_none {
    border: 1px solid #F91616;
  }
  .active_text{
    color: #F91616;
  }
}
</style>
